export const validateDocumentLoadingComplete = (val: GenericObject) =>
  val && !!Object.keys(val).length && val[Object.keys(val)[0]]?.percentage === 100;
